import React, { FC, useEffect, useRef, useState } from 'react'
import { Modal, Row, Table, Input, Col, Tabs, Timeline } from 'antd'
import { ColumnsType, TablePaginationConfig } from 'antd/es/table'
import { assetsListModel } from '../assetsListModel'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants'
import { transPgToPagination } from '@/model/globalModel'
import { assetsListService, IAssetsListDetail } from '../assetsListService'
import { ISearchPage } from '@/types/AppTypes'
import { ModeType } from '@/model/navModel'
import { useDictModel } from '@/views/base/dict/dictModel'
import { FormItemTypeEnum, IYhFormBox, IYhFormItemsBox, IYhFormRef } from '@/components/YhFormBox/Types'
import { YhFormBox } from '@/components/YhFormBox'
import { ClockCircleOutlined, SmileOutlined, SyncOutlined } from '@ant-design/icons'
import { spawn } from 'child_process'
import { DictCodeEnmu } from '@/types/AppDictEnums'
import { momentFormat } from '@/utils/utils'

const { Search } = Input

export const MaterialCodeModal = () => {
    const { materialCodeVisible: visible, setMaterialCodeVisible, materialCodeRow } = assetsListModel()
    const initPgCfg: TablePaginationConfig = { pageSize: 10, current: DEFAULT_FIRST_PAGE_NUM }
    const [dataSource, setDataSource] = useState<IAssetsListDetail[]>([])
    const { getSelectedDictOne,getTreeSelectOne } = useDictModel(() => []);
    //tabs分类详情
    const [tabsActiveDetails, setTabsactiveDetails] = useState<'AssetDetails' | 'flowRecord' | string>('AssetDetails')
    const formRef = useRef<IYhFormRef>()

    useEffect(() => {
        if (tabsActiveDetails == 'flowRecord') {
            flowRecordLoadData()
        }
    }, [tabsActiveDetails])

    const baseFormItem: IYhFormItemsBox = {
        title: <span style={{ marginLeft: '-20px' }}>基础信息</span>,
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '物资编码',
                fieldName: 'materialCode',
                disable: true,
                placeholder: '自动生成',
                span:8
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '物资名称',
                fieldName: 'materialName',
                span:8
            },
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: '物资条码',
            //     fieldName: 'barCode',
            //     span:8
            // },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '品牌',
                fieldName: 'brandName',
                span:8
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '管理人',
                fieldName: 'user',
                span:8
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '物资类型',
                fieldName: 'typeName',
                span:8
                
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '采购时间',
                fieldName: 'createTime',
                span:8
            },

            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '单位',
                fieldName: 'unitName',
                span:8
            },
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: '所属仓库',
            //     fieldName: 'warehouseName',
            //     span:8
            // },
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: '所属货位',
            //     fieldName: 'shelfCode',
            //     span:8
            // },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '供应商名称',
                fieldName: 'supplierName',
                span:8
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '物资类型',
                fieldName: 'typeName',
                span:8
            },          
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '库存数量',
                fieldName: 'inventoryNum',
                span:8
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '占用数量',
                fieldName: 'inventoryOccupied',
                span:8
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '可用数量',
                fieldName: 'availableStock',
                span:8
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '进货价',
                fieldName: 'price',
                span:8
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '采购单号',
                fieldName: 'code',
                span:8
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '规格型号',
                fieldName: 'model',
                span:24,
                labelCol:{span:2}
            },
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: '产品照片',
            //     fieldName: 'weiding',
            // },
        ],
    }

    const AssetsArchivesFromConfig: IYhFormBox<any> = {
        formRef,
        labelAlign: 'right',
        formValues: materialCodeRow,
        boxs: [baseFormItem],
        disabled: true,
        labelCol: { span: 6 },
    }
    const flowRecordLoadData = async () => {
        const searchParams = {
            pageSize: -1,
            pageNum: 1,
            materialCode: materialCodeRow ? materialCodeRow.materialCode : '',
        }
        let { retData } = await assetsListService.flowRecordPage(searchParams)
        const { records } = retData
        setDataSource(records)
    }
    const onOk = () => {}

    return (
        <Modal
            visible={visible}
            // title="选择商品"
            onCancel={() => {
                setMaterialCodeVisible(false)
            }}
            onOk={onOk}
            width={950}
        >
            <Tabs
                defaultActiveKey={tabsActiveDetails}
                type="card"
                onChange={(e) => {
                    setTabsactiveDetails(e)
                }}
            >
                <Tabs.TabPane tab="资产详情" key="AssetDetails"></Tabs.TabPane>
                <Tabs.TabPane tab="流转记录" key="flowRecord"></Tabs.TabPane>
            </Tabs>
            {tabsActiveDetails == 'AssetDetails' && <YhFormBox {...AssetsArchivesFromConfig} />}
            {tabsActiveDetails == 'flowRecord' && (
                <Timeline mode={'left'} style={{marginLeft: '-437px'}}>
                    {dataSource.length>0?dataSource.map((item) => {
                        return (
                            <Timeline.Item color="green" style={{margin:'30px'}}   label={item.createTime?momentFormat(item.createTime):''}>
                                <div>
                                    <div style={{ fontSize: '17px', fontWeight: 'bolder',marginBottom:'8px',color:'#00b8e2' }}>流转记录</div>
                                    <Row style={{ fontSize: '14px'}}>
                                        <span style={{fontSize: '15px', fontWeight:600}}>{item.code.substring(0,2)=='RK'?'入库单号：':item.code.substring(0,2)=='LQ'?'领取单号：':item.code.substring(0,2)=='GH'?'归还单号：':item.code.substring(0,2)=='BF'?'报废单号：':item.code.substring(0,2)=='ZY'?'转移单号：':"单号"} </span>{item.code}
                                    </Row>
                                    <Row style={{ fontSize: '14px'}}>
                                        <span style={{fontSize: '15px', fontWeight:600}}>使用部门： </span>{item.department}
                                        <span style={{fontSize: '15px', marginLeft: '20px',fontWeight:600 }}>使用人:  </span>{item.user}
                                    </Row>
                                    <Row style={{ fontSize: '14px' }}>
                                        <span style={{fontSize: '15px', fontWeight:600}}>存放地点:  </span>{item.deposit}
                                        <span style={{fontSize: '15px', marginLeft: '20px',fontWeight:600 }}>状态:  </span>{getSelectedDictOne(DictCodeEnmu.ASSETS_STATUS).find((list) => list.value === item.status)?.label}
                                    </Row>
                                    <Row style={{ fontSize: '14px' }}>
                                        <span style={{fontSize: '15px', fontWeight:600}}>仓库:  </span>{item.warehouseName}
                                        <span style={{fontSize: '15px', marginLeft: '20px',fontWeight:600 }}>货位:  </span>{item.shelfCode}
                                    </Row>
                                </div>
                            </Timeline.Item>
                        )
                    }):<span style={{margin:'30px'}}>暂无流转记录 <SyncOutlined spin /></span>}
                </Timeline>
            )}
        </Modal>
    )
}
